import {createUseStyles} from "react-jss";
import {colors} from "../../constants/colors";

const styles = createUseStyles(theme => ({
  inputWrapper: {
    position: "relative"
  },
  input: {
    height: "44px",
    width: "100%",
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    padding: "0 0 0 50px",
    textOverflow: "ellipsis",
    "&:focus": {
      outline: "none"
    },
    "&::placeholder": {
      color: colors.inactiveGrey,
    }
  },
  editableInput: {
    paddingRight: "46px !important"
  },
  icon: {
    cursor: "pointer",
    backgroundColor: colors.white,
    border: "1px solid " + colors.darkGrey,
    borderRadius: "8px",
    borderStartStartRadius: "unset",
    borderEndStartRadius: "unset",
    position: "absolute",
    top: "0",
    bottom: "0",
    right: "0",
    width: "44px",
    display: "flex",
    "& svg": {
      margin: "auto",
      width: "22px",
      height: "22px"
    }
  },
  disabledIcon:{
    backgroundColor: `${colors.brightBlue} !important`,
    pointerEvents: "none",
    "& svg": {
      "& path":{
        stroke: colors.inactiveGrey
      }
    },
  }
}));

export default styles;
